import styled from 'styled-components'
import PageLayout from 'layouts/PageLayout'

/**
 * Fix container allowing content to grow too big
 * https://github.com/sketch-hq/Sketch/issues/42480#issuecomment-1099237339
 */
export const StyledPageLayout = styled(PageLayout)`
  flex-basis: 0;
  min-height: 0;

  /* We can't use theme tokens here, we need always dark background for
  prototypes pages.
  @TODO: We can switch to using an additional nested ThemeProvider hard
  coded to the dark theme for the v2 prototype navigation header project */
  background-color: #212121;
`
